<template>
    <v-container fluid>
        <v-card class="pa-4">
            <v-card-title class="text-h5 mb-4">
                Реквизиты
            </v-card-title>

            <v-card-text>
                <v-form ref="form" @submit.prevent="submitForm">
                    <!-- Add Cargo Type Name field (required by CargoType entity) -->
                    <v-text-field v-model="cargoTypeName" label="Название типа груза"
                        :rules="computedCargoTypeNameRules" counter outlined class="mb-4" type="text" />

                    <v-text-field v-model="ownerCompanyName" label="Полное название" :rules="computedFullNameRules"
                        counter outlined class="mb-4" type="text" />

                    <v-text-field v-model="ownerCompanyAddr" label="Адрес" :rules="computedAddressRules" counter
                        outlined class="mb-4" type="text" />

                    <v-text-field v-model="ownerCompanyBank" label="Банк" :rules="computedBankRules" counter outlined
                        class="mb-4" type="text" />

                    <v-text-field v-model="logisticCompanyName" label="Логистическая компания"
                        :rules="computedLogisticCompanyRules" counter outlined class="mb-4" type="text" />

                    <v-text-field v-model="logisticCompanyAddr" label="Адрес логистической компании"
                        :rules="computedLogisticAddressRules" counter outlined class="mb-4" type="text" />

                    <v-text-field v-model="logisticCompanyBank" label="Банк логистической компании"
                        :rules="computedLogisticBankRules" counter outlined class="mb-4" type="text" />

                    <v-text-field v-model="signPostName" label="Должность руководителя" counter outlined class="mb-4"
                        type="text" />

                    <v-text-field v-model="signChief" label="ФИО руководителя" counter outlined class="mb-4"
                        type="text" />

                    <v-text-field v-model="contractNumber" label="Номер договора" counter outlined class="mb-4"
                        type="text" />

                    <v-menu ref="contractStartDateMenu" v-model="contractStartDateMenu" :close-on-content-click="false"
                        transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="formattedContractStartDate" label="Дата договора"
                                prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" outlined class="mb-4" />
                        </template>
                        <v-date-picker v-model="contractStartDate" no-title scrollable
                            @input="contractStartDateMenu = false" />
                    </v-menu>

                    <v-text-field v-model="mainCompanyName" label="Организация хранитель" counter outlined class="mb-4"
                        type="text" />

                    <v-text-field v-model="mainCompanyAddr" label="Адрес хранителя" counter outlined class="mb-4"
                        type="text" />

                    <v-text-field v-model="mainSignChief" label="Руководитель хранителя" counter outlined class="mb-4"
                        type="text" />

                    <v-text-field v-model="ndsPercent" label="НДС %" :rules="computedVatRateRules" type="number"
                        step="1" min="0" max="100" outlined class="mb-4" />

                    <v-btn type="submit" color="primary" :loading="loading">
                        Сохранить настройки
                    </v-btn>

                    <v-alert v-if="successMessage" type="success" class="mt-4">
                        {{ successMessage }}
                    </v-alert>
                    <v-alert v-if="errorMessage" type="error" class="mt-4">
                        {{ errorMessage }}
                    </v-alert>
                </v-form>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import router from '../../router';

export default {
    name: 'EditShipperDocsSettings',

    data() {
        return {
            cargoTypeID: null,
            loading: false,
            successMessage: '',
            errorMessage: '',
            shouldValidate: false,
            contractStartDateMenu: false,

            // CargoType fields
            cargoTypeName: '',

            // ShipperDocSettings fields
            ownerCompanyName: '',
            ownerCompanyAddr: '',
            ownerCompanyBank: '',
            logisticCompanyName: '',
            logisticCompanyAddr: '',
            logisticCompanyBank: '',
            signPostName: '',
            signChief: '',
            contractNumber: '',
            contractStartDate: null,
            mainCompanyName: '',
            mainCompanyAddr: '',
            mainSignChief: '',
            ndsPercent: 0
        }
    },

    computed: {
        formattedContractStartDate() {
            return this.contractStartDate ?
                new Date(this.contractStartDate).toLocaleDateString('ru-RU') : '';
        },

        computedCargoTypeNameRules() {
            if (!this.shouldValidate) return [];
            return [
                v => !!v || 'Название типа груза обязательно'
            ];
        },

        computedFullNameRules() {
            if (!this.shouldValidate) return [];
            return [
                v => !!v || 'Полное название обязательно'
            ];
        },

        computedAddressRules() {
            if (!this.shouldValidate) return [];
            return [
                v => !!v || 'Адрес обязателен'
            ];
        },

        computedBankRules() {
            if (!this.shouldValidate) return [];
            return [
                v => !!v || 'Банк обязателен'
            ];
        },

        computedLogisticCompanyRules() {
            if (!this.shouldValidate) return [];
            return [
                v => !!v || 'Логистическая компания обязательна'
            ];
        },

        computedLogisticAddressRules() {
            if (!this.shouldValidate) return [];
            return [
                v => !!v || 'Адрес логистической компании обязателен'
            ];
        },

        computedLogisticBankRules() {
            if (!this.shouldValidate) return [];
            return [
                v => !!v || 'Банк логистической компании обязателен',
                v => (v && v.length <= 100) || 'Банк должен содержать максимум 100 символов'
            ];
        },

        computedVatRateRules() {
            if (!this.shouldValidate) return [];
            return [
                v => v !== null && v !== undefined || 'Процент НДС обязателен',
                v => !isNaN(parseInt(v)) || 'Процент НДС должен быть числом',
                v => (parseInt(v) >= 0 && parseInt(v) <= 100) || 'Процент НДС должен быть между 0 и 100'
            ];
        }
    },

    created() {
        this.cargoTypeID = this.$route.params.cargoTypeID;
        if (this.cargoTypeID) {
            this.loadData();
        }
    },

    methods: {
        async loadData() {
            try {
                const cargoTypeID = parseInt(this.$route.params.cargoTypeID, 10);
                if (!cargoTypeID) {
                    console.error('cargoTypeID не определен');
                    return;
                }

                const response = await this.axios.get(`/CargoTypes/${cargoTypeID}`);

                if (response.data) {
                    // Fill CargoType fields
                    this.cargoTypeName = response.data.name || '';

                    // Fill ShipperDocSettings fields if they exist
                    if (response.data.shipperDocSettings) {
                        const settings = response.data.shipperDocSettings;
                        this.ownerCompanyName = settings.ownerCompanyName || '';
                        this.ownerCompanyAddr = settings.ownerCompanyAddr || '';
                        this.ownerCompanyBank = settings.ownerCompanyBank || '';
                        this.logisticCompanyName = settings.logisticCompanyName || '';
                        this.logisticCompanyAddr = settings.logisticCompanyAddr || '';
                        this.logisticCompanyBank = settings.logisticCompanyBank || '';
                        this.signPostName = settings.signPostName || '';
                        this.signChief = settings.signChief || '';
                        this.contractNumber = settings.contractNumber || '';
                        this.contractStartDate = settings.contractStartDate ?
                            settings.contractStartDate.split('T')[0] : null;
                        this.mainCompanyName = settings.mainCompanyName || '';
                        this.mainCompanyAddr = settings.mainCompanyAddr || '';
                        this.mainSignChief = settings.mainSignChief || '';
                        this.ndsPercent = settings.ndsPercent || 0;
                    }
                }
            } catch (error) {
                console.error('Ошибка загрузки данных:', error);
                if (error.response?.status === 404) {
                    this.errorMessage = 'Грузоперевозчик не найден';
                } else {
                    this.errorMessage = 'Не удалось загрузить данные';
                }
            }
        },

        async submitForm() {
            this.shouldValidate = true;
            await this.$nextTick();

            const isValid = this.$refs.form.validate();
            if (!isValid) {
                this.errorMessage = 'Пожалуйста, исправьте ошибки в форме';
                this.scrollToFirstError();
                return;
            }

            this.loading = true;
            this.successMessage = '';
            this.errorMessage = '';

            try {
                const cargoTypeID = parseInt(this.$route.params.cargoTypeID, 10);

                if (isNaN(cargoTypeID)) {
                    this.errorMessage = 'Некорректный ID грузоперевозчика';
                    return;
                }

                // Prepare the update DTO matching your backend UpdateCargoTypeDto
                const updateData = {
                    id: cargoTypeID,
                    name: this.cargoTypeName,
                    shipperDocSettings: {
                        ownerCompanyName: this.ownerCompanyName,
                        ownerCompanyAddr: this.ownerCompanyAddr,
                        ownerCompanyBank: this.ownerCompanyBank,
                        logisticCompanyName: this.logisticCompanyName,
                        logisticCompanyAddr: this.logisticCompanyAddr,
                        logisticCompanyBank: this.logisticCompanyBank,
                        signPostName: this.signPostName,
                        signChief: this.signChief,
                        contractNumber: this.contractNumber,
                        contractStartDate: this.contractStartDate ?
                            new Date(this.contractStartDate).toISOString() : null,
                        mainCompanyName: this.mainCompanyName,
                        mainCompanyAddr: this.mainCompanyAddr,
                        mainSignChief: this.mainSignChief,
                        ndsPercent: parseInt(this.ndsPercent) || 0
                    }
                };

                // Make the PUT request to update the cargo type
                const response = await this.axios.put(
                    `/CargoTypes/${cargoTypeID}`,
                    updateData,
                    {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }
                );

                // Check for successful response (204 No Content)
                if (response.status === 204) {
                    this.successMessage = 'Настройки успешно сохранены!';
                    setTimeout(() => {
                        router.push('/settings/cargoTypes');
                    }, 2000);
                }
            } catch (error) {
                console.error('Error saving settings:', error);

                if (error.response) {
                    if (error.response.status === 400) {
                        this.errorMessage = error.response.data?.message || 'Ошибка валидации данных';
                    } else if (error.response.status === 404) {
                        this.errorMessage = 'Грузоперевозчик не найден';
                    } else if (error.response.status === 500) {
                        this.errorMessage = 'Внутренняя ошибка сервера';
                    } else {
                        this.errorMessage = error.response.data?.message || 'Ошибка сохранения настроек';
                    }
                } else if (error.request) {
                    this.errorMessage = 'Нет ответа от сервера. Проверьте подключение к интернету.';
                } else {
                    this.errorMessage = 'Ошибка при отправке запроса: ' + error.message;
                }
            } finally {
                this.loading = false;
            }
        },

        resetForm() {
            this.shouldValidate = false;
            this.$refs.form.reset();
            this.successMessage = '';
            this.errorMessage = '';
            this.contractStartDate = null;
        },

        scrollToFirstError() {
            this.$nextTick(() => {
                const errorField = this.$el.querySelector('.v-messages__message');
                if (errorField) {
                    errorField.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center'
                    });
                }
            });
        }
    }
}
</script>